import styled from 'styled-components'

export const HomeWrapper = styled.div`
    width: 100%;
    margin-top: 1rem;
    .swiper {
        /* width: 100%;
        height: 100%; */
        .swiper-pagination {
            .swiper-pagination-bullet {
                font-size: 3rem;
            }    
        } 
    }
`
export const HomeImageWrapper = styled.div`
    padding: 1rem 7vw;
    margin-top: 2rem;
    /* border: 2px solid blue; */
`
export const FirstGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    div {
        overflow: hidden;
        border-radius: 10px;
        img {
            transition: transform 500ms;
            &:hover {
                transform: scale(1.3);
            }
        }
    }
    @media (min-width: 620px) {
        padding: 0 10vw;
    }
    @media (min-width: 1000px) {
        grid-template-columns: 1fr 1fr 1fr;
        padding: 0;
    }
`
export const SecondGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 2rem;
    div {
        overflow: hidden;
        border-radius: 10px;
        img {
            transition: transform 500ms;
            &:hover {
                transform: scale(1.3);
            }
        }
    }
    @media (min-width: 620px) {
        grid-template-columns: 1fr 1fr;
    }
    /* 
    @media (min-width: 1100px) {
        grid-template-columns: 1fr 1fr;
    } */
`
